import type { PlusStatus } from '../dataProvider/types';

/** Display helpers for the Subscriptions surface. */

/** Human label per Plus state. The two lapsed states read DISTINCTLY so the
 *  recoverable group (insufficient funds) is never confused with a chosen lapse. */
export const STATUS_LABEL: Record<PlusStatus, string> = {
  none: 'None',
  active: 'Active',
  pending_cancel: 'Pending cancel',
  lapsed: 'Lapsed',
  lapsed_insufficient: 'Lapsed (insufficient funds)',
};

/** MUI chip colour per state: active healthy, pending_cancel attention, the two
 *  ended states muted, with insufficient-funds flagged as the recoverable one. */
export const STATUS_COLOR: Record<
  PlusStatus,
  'success' | 'warning' | 'error' | 'default'
> = {
  none: 'default',
  active: 'success',
  pending_cancel: 'warning',
  lapsed: 'default',
  lapsed_insufficient: 'error',
};

/** A period-end timestamp as a plain calendar date (deterministic, no locale). */
export const formatPeriodEnd = (iso: string | null): string =>
  iso == null ? '—' : new Date(iso).toISOString().slice(0, 10);

/** Auto-renew state as a word, the dispute-answering field. */
export const formatAutoRenew = (on: boolean): string => (on ? 'On' : 'Off');
